import React from 'react';
const StepperBar = ({ currentStep, totalSteps }) => {
    const completePercentage = (currentStep / totalSteps) * 100;
    return (React.createElement("div", { className: "h-1.5 w-full", role: "progressbar", "aria-valuemin": 0, "aria-valuemax": totalSteps, "aria-valuenow": currentStep },
        React.createElement("div", { className: "h-full rounded-r-full bg-blue-600 transition-all duration-500 motion-reduce:transition-none", style: { width: `${completePercentage}%` } })));
};
export default StepperBar;
